import { render, staticRenderFns } from "./IbxAppContent.vue?vue&type=template&id=7837cad1"
import script from "./IbxAppContent.vue?vue&type=script&lang=js"
export * from "./IbxAppContent.vue?vue&type=script&lang=js"
import style0 from "./IbxAppContent.vue?vue&type=style&index=0&id=7837cad1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports